import { enableSpinner } from './spinner.js';

//In order for this submit event to work the submit button should have a "name" attribute with the "button" as value.
function addEvents() {
    var forms = document.querySelectorAll("form");
    for (var form of forms) {
        form.addEventListener("submit", function(event) {
            if ($(this).valid()) {
                this.button.disabled = true; 
                enableSpinner();
            }
        });
    }
}

//document ready in plain javascript
if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    addEvents();
} else {
    document.addEventListener("DOMContentLoaded", addEvents);
}